import clsx from 'clsx';
import { useCallback, useEffect, useRef } from 'react';
import config from '../config';
import { fetchImage, handleFetchImage } from '../utils/canvas';
import { getTraitImagePath } from '../utils/traits';
import Spinner from './Spinner';

const DEFAULT_WIDTH = 3000;
const DEFAULT_HEIGHT = 3000;

const KittyImageLayers = ({ metadata, className }) => {
  const canvasRef = useRef(null);

  const getPropValue = useCallback(
    (property, _index) => {
      const nft = metadata;
      if (!nft) return '';
      return nft.properties[property];
    },
    [metadata]
  );

  useEffect(() => {
    if (!metadata) return;

    const images = config.fourthLitterTraitLayers.map((property) => {
      const propValue = getPropValue(property);
      const imageUrl = getTraitImagePath(property, propValue);

      return {
        src: imageUrl,
        x: 0,
        y: 0,
        width: DEFAULT_WIDTH,
        height: DEFAULT_HEIGHT,
      };
    });

    const canvasContext = canvasRef.current?.getContext('2d');
    if (!canvasContext) return;

    Promise.all(images.map(fetchImage)).then((results) =>
      results.forEach((result) => {
        handleFetchImage(canvasContext, result);
      })
    );
  }, [metadata]);

  return (
    <div className={clsx('relative aspect-square w-full max-w-[750px] overflow-hidden rounded-lg bg-gray-900', className)}>
      <canvas ref={canvasRef} width={3000} height={3000} className='h-full w-full rounded-lg z-20 relative' />
      <div className='absolute left-0 top-0 z-10 w-full h-full bg-black/50 flex items-center justify-center'>
        <Spinner />
      </div>
    </div>
  );
};

export default KittyImageLayers;
